import i18n from '../i18n';
import StaticTemplates from '@staticTemplate/htmlTemplates.js'

export const LANGUAGE_DEFAULT = 'es'
export const SECTION_HOME_ALIADOS_NAME = 'Home Aliados'
export const SECTION_TEMPLATE_TYPES = Object.freeze({
  DEFAULT: 'default',
  HOME_ALIADOS: 'homeAliados',
})

export const AUTHORIZATION = 'auth'
export const DATA_USER = 'user'
export const CURRENT_LENGUAGE = 'current_lenguage'

export const SECTION_HOME_ID = 1
export const SECTION_DOCUMENT_ID = 10
export const SECTION_CONTAINER_DOCUMENT_ID = 9

export const rexgexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const StatusConst = Object.freeze({
  IS_ACTIVE: 1,
  IS_SUSPENDED: 0
})

export const StatusVisible = Object.freeze({
  IS_VISIBLE: 1,
  IS_HIDDEN: 0
})

export const StatusDelete = Object.freeze({
  IS_VISIBLE: 0,
  CONFIRM_DELETE: 1
})
export const StatusReading = Object.freeze({
  IS_READING: 0,
  NOT_READING: 1
})

export const StatusPrincipal = Object.freeze({
  IS_PRINCIPAL: 1,
  NOT_PRINCIPAL: 0
})

export const StatusRestringido = Object.freeze({
  IS_RESTRINGIDO: 1,
  NOT_RESTRINGIDO: 0
})

export const AuthorizedStatus = Object.freeze({
  STATUS_AUTHORIZED: 'Autorizado',
  STATUS_PENDING: 'Pendiente',
  STATUS_EDITION: 'En edición',
  STATUS_REJECTED: 'Rechazado',
  STATUS_IN_UPDATE: 'En actualización',
  STATUS_IN_PROCESS: 'En proceso',
  STATUS_IN_ACTION: 'En ejecución',
  STATUS_CANCEL: 'Cancelado',
  STATUS_FINISHED: 'Terminado',
  STATUS_INACTIVE: 'Inactivo',
})

export const AuthorizedStatusInt = Object.freeze({
  STATUS_AUTHORIZED: 4,
  STATUS_PENDING: 2,
  STATUS_EDITION: 1,
  STATUS_REJECTED: 3,
  STATUS_IN_UPDATE: 5,
  STATUS_INACTIVE: 12,
})

export const AuthorizedStatusSend = Object.freeze({
  STATUS_AUTHORIZED: 'authorized',
  STATUS_PENDING: 'pending',
  STATUS_EDITION: 'edit',
  STATUS_REJECTED: 'rejected',
})

export const StatusString = Object.freeze({
  STATUS_DELETED: 'deleted',
  STATUS_ACTIVE: 'active',
  STATUS_SUSPENDED: 'suspended',
  STATUS_SHOWABLE: 'showable',
})

export const StatusBulkLoad = Object.freeze({
  STATUS_ALL: 'all',
  STATUS_IN_PROCESS: 'processing',
  STATUS_PENDING: 'pending',
  STATUS_IN_ACTION: 'executing',
  STATUS_CANCELLED: 'cancelled',
  STATUS_REJECTED: 'rejected',
  STATUS_FINISHED: 'finished',
})

export const IS_ERASABLE = 1
export const NOT_ERASABLE = 0

export const DAY_NAMES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
export const MONTH_NAMES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']

// Permissions
export const PERMISSION_SECCION = "Secciones"
export const PERMISSION_USER = "Usuarios"
export const PERMISSION_DIGITAL_FORM = "Formularios Digitales"
export const PERMISSION_DOCUMENTS = "Documentos"
export const PERMISSION_REPORTS = "Reportes"
export const PERMISSION_INTEREST = "Sitios de interés"
export const PERMISSION_PROCESS = "Procesos"
export const PERMISSION_ADMINISTRATION = "Administración"


export const LANGUAGE_AND_CODE = [
  { code: "af", name: "Afrikaans" },
  { code: "ar", name: "Arábica" },
  { code: "az", name: "Azerbaiyano" },
  { code: "be", name: "Bielorruso" },
  { code: "bg", name: "Búlgaro" },
  { code: "bm", name: "Bambara" },
  { code: "bn", name: "Bengali" },
  { code: "bo", name: "Tibetano" },
  { code: "br", name: "Breton" },
  { code: "bs", name: "Bosnio" },    
  { code: "ca", name: "Catalan" },
  { code: "cs", name: "Checo" },
  { code: "cv", name: "Chuvash" },
  { code: "cy", name: "Galés" },   
  { code: "da", name: "Danés" },
  { code: "de", name: "Alemán" },
  { code: "dv", name: "Divehi" }, 
  { code: "el", name: "Griego" },
  { code: "en", name: "Inglés" },
  { code: "eo", name: "Esperanto" },
  { code: "es", name: "Español" },
  { code: "et", name: "Estonio" },
  { code: "eu", name: "Vasco" },    
  { code: "fa", name: "Persa" },
  { code: "fi", name: "Finlandés" },
  { code: "fil", name: "Filipino" },
  { code: "fo", name: "Feroés" },
  { code: "fr", name: "Francés" },
  { code: "fy", name: "Frisón occidental" },
  { code: "gd", name: "Gaélico escocés" },
  { code: "gl", name: "Gallego" },
  { code: "gom-latn", name: "gom (Latin)" },
  { code: "gu", name: "Gujarati" }, 
  { code: "he", name: "Hebreo" },
  { code: "hi", name: "Hindi" },
  { code: "hr", name: "Croata" },
  { code: "hu", name: "Húngaro" },
  { code: "hy-am", name: "Armenia" }, 
  { code: "id", name: "Indonesian" },
  { code: "is", name: "Islandés" },
  { code: "it", name: "Italiano" }, 
  { code: "ja", name: "Japonés" },
  { code: "jv", name: "Javanés" }, 
  { code: "ka", name: "Georgiano" },
  { code: "kk", name: "Kazajo" },
  { code: "km", name: "Jemer" },
  { code: "kn", name: "Canarés" },
  { code: "ko", name: "Coreano" },
  { code: "ku", name: "Kurdo" },
  { code: "ky", name: "Kirguís" }, 
  { code: "lb", name: "Luxemburgués" },
  { code: "lo", name: "Lao" },
  { code: "lt", name: "Lituano" },
  { code: "lv", name: "Letón" },
  { code: "me", name: "Montenegrino" },
  { code: "mi", name: "Maorí" },
  { code: "mk", name: "Macedonian" },
  { code: "ml", name: "Malayalam" },
  { code: "mn", name: "Mongol" },
  { code: "mr", name: "Marathi" }, 
  { code: "ms", name: "Malayo" },
  { code: "mt", name: "Maltés" },
  { code: "my", name: "Birmano" },
  { code: "nb", name: "Norwegian Bokmål" },
  { code: "ne", name: "Nepali" }, 
  { code: "nl", name: "Holandés" },
  { code: "nn", name: "Noruego Nynorsk" }, 
  { code: "pa-in", name: "Punjabi (India)" }, 
  { code: "pl", name: "Polaco" },
  { code: "pt", name: "Portugués" }, 
  { code: "ro", name: "Rumano" },
  { code: "ru", name: "Ruso" },  
  { code: "sd", name: "Sindhi" },
  { code: "se", name: "Sami del norte" },
  { code: "si", name: "Cingalés" },
  { code: "sk", name: "eslovaco" },
  { code: "sl", name: "Esloveno" },  
  { code: "sq", name: "Albanés" },
  { code: "sr", name: "Serbio" },
  { code: "ss", name: "Swati" },
  { code: "sv", name: "Sueco" },
  { code: "sw", name: "Swahili" },  
  { code: "ta", name: "Tamil" },
  { code: "te", name: "Telugu" },
  { code: "tet", name: "Tetum" },
  { code: "tg", name: "Tayiko" },
  { code: "th", name: "Tailandés" }, 
  { code: "tk", name: "Turcomano" }, 
  { code: "tl-ph", name: "Tagalo" },
  { code: "tlh", name: "Klingon" },
  { code: "tr", name: "Turco" }, 
  { code: "tzl", name: "Talossan" }, 
  { code: "ug-cn", name: "Uigur (China)" }, 
  { code: "uk", name: "Ucranio" }, 
  { code: "ur", name: "Urdu" },
  { code: "uz", name: "Uzbeko" },  
  { code: "vi", name: "vietnamita" },  
  { code: "x-pseudo", name: "Seudo" },  
  { code: "yo", name: "Yoruba (Nigeria)" },  
  { code: "zh-cn", name: "Chino" }
]

export const settingEditorEmail = {
  height: 800,
  plugins: [
    'advlist autolink lists link image print preview',
    'searchreplace visualblocks fullscreen',
    'paste code help wordcount template'
  ],
  toolbar:
  'bold italic backcolor ' +
  'alignleft aligncenter alignright alignjustify ',
  content_style: 'body { font-family: Roboto, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 300; color: #3C3C3C; text-align: center; line-height: 1.6; }',
  selector: 'textarea#open-source-plugins',
  imagetools_cors_hosts: ['picsum.photos'],
  menubar: 'tools insert',
  templates: [
    { title: i18n.t('Email con liga'), description: i18n.t('Plantilla email con liga'), content: StaticTemplates[5].templete},
    { title: i18n.t('Email con botón'), description: i18n.t('Plantilla email con botón'), content: StaticTemplates[6].templete},
  ],
  toolbar_sticky: true,
  table_resize_bars: false,
  table_cell_advtab: false,
  table_advtab: false,
  resizable: false,
  object_resizing : false, // Solo se puede cambiar tamaño para:  || not(table)
  table_sizing_mode: 'auto',
  branding: false
}

export const TypeProcess = Object.freeze({
  PDD: 'PDD',
  PDDC: 'PDDC',
  PRGEH: 'PRGEH',
  PCI: 'PCI',
  PC:'PC'
})

export const IconsEmails = [
  {"icon": "icon-check", url: "https://www.complianceamx.com/img/email/ico-check.png", with: "60px", height: "60px"},
  {"icon": "icon-cumplilimiento", url: "https://www.complianceamx.com/img/email/ico-cumplimiento.png", with: "60px", height: "60px", extraClass: "icon-large"},
  {"icon": "ico-delete", url: "https://www.complianceamx.com/img/email/ico-delete.png", with: "60px", height: "60px"},
  {"icon": "ico-email", url: "https://www.complianceamx.com/img/email/ico-email.png", with: "60px", height: "60px"},
  {"icon": "ico-error", url: "https://www.complianceamx.com/img/email/ico-error.png", with: "60px", height: "60px"},
  {"icon": "ico-user", url: "https://www.complianceamx.com/img/email/ico-user.png", with: "60px", height: "60px"},
  {"icon": "ico-accesos", url: "https://www.complianceamx.com/img/email/ico_accesos.png", with: "60px", height: "60px"},
  {"icon": "ico-conclusion-proceso", url: "https://www.complianceamx.com/img/email/ico_conclusion_proceso.png", with: "60px", height: "60px"},
]

// Formularios digitales
export const MAIN_CLASS_HTML_DIGITAL_FORM = "contFlexSP"
